var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-book-user-reviews-count label label-sm label-round"},[_vm._v("\n  "+_vm._s(_vm.userReviewsCount)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }